<template>
  <div class='trade-page'>
    <div class='trade-page-container'>
      <div class='trade-chart-container' :class="{ mobile: $mq === 'mobile' }">
        <header class='trade-toolbar'>
          <p class='market-symbol'>
            <i class='sr sr-swaparrow-horizontal'></i>
            {{ brand.symbol | symbol }} <span class="exchange-code">/ {{ brand.exchange_server_code ?? '--' }}</span>
            <brand-selector />
          </p>
          <div class='trade-toolbar-item'>
            <p class='trade-toolbar-item__text'>{{$t('trade.closing-price')}}</p>
            <p class='trade-toolbar-item__value'>
              {{
                brand.stype === 2 && brand.bond_type === 100
                    ? brand.closing_price * 1000
                    : brand.closing_price | currency('', '')
              }}MNT
            </p>
          </div>
          <div class='trade-toolbar-item'>
            <p class='trade-toolbar-item__text'>{{$t('trade.trading-hours')}}</p>
            <p class='trade-toolbar-item__value'>{{  tradeDate }}</p>
          </div>
        </header>
        <trade-chart ref='tradingChart' />
      </div>
      <!-- Захиалгын сан -->
      <div class='trade-history-container'>
        <fast-component
          class='p-0'
          :brand='brand'
          :symbol='brand.symbol'
          @order='getActiveOrder'
        ></fast-component>
      </div>
      <open-orders class='trade-page-open-orders' />

      <div class='trade-order-container' v-if="$mq !== 'mobile'">
        <div v-if='brand && brand.symbol && !brand.sell_type'
          class='trade-actions'>
          <order :selectedOrder='selectedOrder' />
        </div>
      </div>
      <div class='mobile-order-actions' v-if="$mq === 'mobile'">
        <ic-button
          block
          size='tn'
          @click="
            mobileOrderType = 'buy'
            showMobileOrder = true
          "
        >
          {{ $t('trade.buy') }}
        </ic-button>
        <ic-button
          block
          size='tn'
          color='danger'
          @click="
            mobileOrderType = 'sell'
            showMobileOrder = true
          "
        >
          {{ $t('trade.sell') }}
        </ic-button>
        <transition name='fade'>
          <div
            v-if='showMobileOrder'
            ref='mobileOrderSheet'
            class='mobile-order-sheet'
            :class='{ open: showMobileOrder }'
            @click.stop='closeIfOutside'
          >
            <transition name='slide-up' appear>
              <order v-if='showMobileOrder' :type='mobileOrderType' />
            </transition>
          </div>
        </transition>
      </div>
    </div>
    <alert :show-alert="user && showContractAlert"  @close="close" :body="alertBody" :pre-body="alertPreBody"/>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_dark from '@amcharts/amcharts4/themes/dark'
import am4themes_material from '@amcharts/amcharts4/themes/material'

import { mapState, mapActions, mapGetters } from 'vuex'
import api from '../../api/stoTrade'
import Order from '../../components/Order'
import OpenOrders from '../../components/OpenOrders'
import OrderTrHistory from '../../components/sidebar/OrderTrHistory'
import FastComponent from '../../components/FastComponent'
import CashOutRequest from '../../components/sidebar/CashOutRequest'
import NewsList from '../../components/sidebar/NewsList'
import BrandSelector from '../../components/BrandSelector'
import TradeChart from '../../components/global/TradeChart'
import ProfitPage from '../../views/ProfitPage'
import Alert from "../../components/Alert.vue";

export default {
  name: 'TradeSto',
  components: {
    Alert,
    CashOutRequest,
    Order,
    OpenOrders,
    ProfitPage,
    'order-trade-history': OrderTrHistory,
    'fast-component': FastComponent,
    'news-list': NewsList,
    'brand-selector': BrandSelector,
    'trade-chart': TradeChart,
  },
  data() {
    return {
      selectedBrand: null,
      openedBrands: false,
      openedProfile: false,
      openedBalance: false,
      closingPrices: [],
      chart: null,
      mobileOrderType: 'buy',
      showMobileOrder: false,
      selectedOrder: null,
      alertBody: 'Та биечлэн эсвэл цахимаар гэрээгээ байгуулах боломжтой бөгөөд гэрээгээ байгуулаагүй тохиолдолд арилжаанд оролцох болон орлого, зарлагын гүйлгээ хийх боломжгүй болохыг мэдээлж байна.',
      alertPreBody: 'Харилцагч Та "Брокерийн үйлчилгээний гэрээ"-гээ байгуулна уу.'
    }
  },
  computed: {
    ...mapState('common', ['sbState', 'dark']),
    ...mapState('brand', ['brand', 'stockType']),
    // ...mapGetters('trade', ['getTradeDate']),
    ...mapGetters('brand', ['tradeDate']),
    ...mapGetters('user', ['user']),
    showContractAlert() {
      if(this.$store.getters['user/closeAlert'] === false && this.main)
        return false;
      return this.$store.getters['user/closeAlert'] !== true;
    },
    contracts() {
      return this.$store.getters['user/contracts']
    },
    main() {
      return this.contracts.find(contract =>(contract.type === 'main' && (contract.status === 'user_signed' || contract.status === 'admin_signed')))
    },
  },
  watch: {
    dark: {
      handler(next) {
        if (next) {
          this.$refs.tradingChart.colorTheme = 'dark'
        } else {
          this.$refs.tradingChart.colorTheme = 'light'
        }
      },
    },
  },
  mounted() {
    if (this.dark) {
      this.$refs.tradingChart.colorTheme = 'dark'
    }
    if (this.brand && this.brand.symbol) {
      this.$store.dispatch('brand/updateCurrentSymbol', {
        brand: this.brand
      })
    }
  },
  methods: {
    closeIfOutside(e) {
      if (e.target.closest('.order-container')) {
        return
      } else {
        this.showMobileOrder = false
      }
    },
    getActiveOrder(value) {
      this.selectedOrder = value
    },
    close() {
      this.$store.dispatch('user/setCloseAlert', true)
    }
  },
}
</script>
<style lang='scss'>
@import './TradeSto.scss';
</style>
